import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm } from '@grandvisionhq/configurator';
import { useIntl } from '@grandvisionhq/state';
import { PupillaryDistanceLinkContainer } from '../../../components/PupillaryDistanceLink/PupillaryDistanceLinkContainer.js';
import PrescriptionFormColumn from '../PrescriptionFormColumn/PrescriptionFormColumn.js';

const PrescriptionForm = ({ idExtension , className , prescription , setLeftParameter , setRightParameter , opticalParameters , prescriptionValidationState , isSubmitted , onSubmit , 'data-t': dataT ,  })=>{
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(StepForm, {
        className: classnames('prescription-form', className),
        "data-t": dataT,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(PrescriptionFormColumn, {
        className: "prescription-form__column",
        id: `right-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.rightEye`),
        parameters: opticalParameters,
        selectedValues: prescription.right,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.right,
        showValidation: isSubmitted,
        onAttributeChange: setRightParameter
    }), isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }), /*#__PURE__*/ React__default.createElement(PrescriptionFormColumn, {
        className: "prescription-form__column",
        id: `left-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.leftEye`),
        parameters: opticalParameters,
        selectedValues: prescription.left,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.left,
        showValidation: isSubmitted,
        onAttributeChange: setLeftParameter,
        hideSelectLabels: !isPhone
    })), /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }));
};

export { PrescriptionForm as default };
//# sourceMappingURL=PrescriptionForm.js.map
